import { WorkflowSchema as _WorkflowSchema } from 'dashboard/models/workflow-schema';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum WorkflowModuleStatus {
  Inactive = 'inactive',
  Active = 'active',
  Archived = 'archived',
}

export interface WorkflowModuleAttributes {
  status: WorkflowModuleStatus;
  name: string;
  description: string;
  'created-at': string;
  'updated-at': string;
  callers: {
    'source-id': string;
    'source-name': string;
    'referenced-block-id': string;
  }[];
}

export interface WorkflowModuleRelationships {
  'latest-draft-block': ApiRelationship<ApiModel.WorkflowBlock> | { data: null };
  'latest-published-block': ApiRelationship<ApiModel.WorkflowBlock> | { data: null };
}

export type WorkflowModule = ApiResource<
  WorkflowModuleAttributes,
  WorkflowModuleRelationships,
  ApiModel.WorkflowModule
>;

export type WorkflowModulePayload = {
  type: ApiModel.WorkflowModule;
  attributes: Pick<WorkflowModuleAttributes, 'name' | 'description'>;
};

export enum WorkflowModulePropagationStatus {
  Completed = 'completed',
  Failed = 'failed',
  Skipped = 'skipped',
  NotFound = 'not_found',
}
export type WorkflowModulePropagationResult =
  | {
      status: WorkflowModulePropagationStatus.Completed;
      workflow: string;
      meta: {
        'num-steps-updated': number;
      };
    }
  | {
      status: WorkflowModulePropagationStatus.Failed;
      workflow: string;
      meta: {
        reason: string;
      };
    }
  | {
      status: WorkflowModulePropagationStatus.NotFound;
      workflow: string;
      meta: Record<string, never>;
    }
  | {
      status: WorkflowModulePropagationStatus.Skipped;
      workflow: string;
      meta: {
        reason: string;
      };
    };
export type WorkflowModulePropagateMeta = {
  results: WorkflowModulePropagationResult[];
};
